export const FETCH_SCHEDULES = "FETCH_SCHEDULES";
export const FETCH_SCHEDULES_SUCCESS = "FETCH_SCHEDULES_SUCCESS";
export const FETCH_SCHEDULES_FAILED = "FETCH_SCHEDULES_FAILED";
export const SET_SCHEDULES = "SET_SCHEDULES";
export const FETCH_SCHEDULE_INFO = "FETCH_SCHEDULE_INFO";
export const FETCH_SCHEDULE_INFO_SUCCESS = "FETCH_SCHEDULE_INFO_SUCCESS";
export const FETCH_SCHEDULE_INFO_FAILED = "FETCH_SCHEDULE_INFO_FAILED";
